"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jaroWinklerSimilarity = exports.jaroSimilarity = void 0;
/**
 * Jaro similarity: a metric in [0, 1] over two strings, where 1 is identical.
 * Counts matching characters (within a sliding window) and penalizes transpositions.
 */
const jaroSimilarity = (s1, s2) => {
    if (s1 === s2) {
        return 1;
    }
    if (s1.length === 0 || s2.length === 0) {
        return 0;
    }
    const matchWindow = Math.max(0, Math.floor(Math.max(s1.length, s2.length) / 2) - 1);
    const s1Matches = new Array(s1.length).fill(false);
    const s2Matches = new Array(s2.length).fill(false);
    let matches = 0;
    for (let i = 0; i < s1.length; i += 1) {
        const start = Math.max(0, i - matchWindow);
        const end = Math.min(i + matchWindow + 1, s2.length);
        for (let j = start; j < end; j += 1) {
            if (s2Matches[j])
                continue;
            if (s1[i] !== s2[j])
                continue;
            s1Matches[i] = true;
            s2Matches[j] = true;
            matches += 1;
            break;
        }
    }
    if (matches === 0) {
        return 0;
    }
    let transpositions = 0;
    let k = 0;
    for (let i = 0; i < s1.length; i += 1) {
        if (!s1Matches[i])
            continue;
        while (!s2Matches[k])
            k += 1;
        if (s1[i] !== s2[k])
            transpositions += 1;
        k += 1;
    }
    return (matches / s1.length + matches / s2.length + (matches - transpositions / 2) / matches) / 3;
};
exports.jaroSimilarity = jaroSimilarity;
/**
 * Jaro-Winkler similarity: Jaro with an explicit bonus for shared prefix characters
 * (up to 4 chars). Designed for name matching — used by the US Census Bureau and credit
 * bureaus because it weights the start of a string heavily, which matches human intuition
 * about typos vs different names.
 *
 * @param prefixScale - Per-prefix-char boost. Standard value 0.1; max 0.25.
 * @param maxPrefixLength - Cap on how many leading shared chars contribute. Standard 4.
 */
const jaroWinklerSimilarity = (s1, s2, prefixScale = 0.1, maxPrefixLength = 4) => {
    const jaro = (0, exports.jaroSimilarity)(s1, s2);
    if (jaro === 0 || jaro === 1) {
        return jaro;
    }
    let prefixLength = 0;
    const limit = Math.min(maxPrefixLength, s1.length, s2.length);
    while (prefixLength < limit && s1[prefixLength] === s2[prefixLength]) {
        prefixLength += 1;
    }
    return jaro + prefixLength * prefixScale * (1 - jaro);
};
exports.jaroWinklerSimilarity = jaroWinklerSimilarity;
